import { render, staticRenderFns } from "./AnalysesPopularCard.vue?vue&type=template&id=f2630b26&scoped=true&"
import script from "./AnalysesPopularCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AnalysesPopularCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AnalysesPopularCard.vue?vue&type=style&index=0&id=f2630b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2630b26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2630b26')) {
      api.createRecord('f2630b26', component.options)
    } else {
      api.reload('f2630b26', component.options)
    }
    module.hot.accept("./AnalysesPopularCard.vue?vue&type=template&id=f2630b26&scoped=true&", function () {
      api.rerender('f2630b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesPopularCard.vue"
export default component.exports